import { motion } from "framer-motion";

export const Reveal = ({
    children,
    delay = 0,
    y = 30,
    className = "",
    testId,
}) => (
    <motion.div
        data-testid={testId}
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.85, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

export const SectionHeader = ({ eyebrow, title, sub, light = false, center = false }) => (
    <div className={`${center ? "text-center" : ""} max-w-3xl ${center ? "mx-auto" : ""}`}>
        <Reveal>
            <p
                className={`font-accent text-[11px] sm:text-xs uppercase tracking-[0.35em] ${
                    light ? "text-gold" : "text-gold-deep"
                }`}
            >
                {eyebrow}
            </p>
        </Reveal>
        <Reveal delay={0.08}>
            <h2
                className={`font-display font-medium text-3xl sm:text-4xl lg:text-5xl leading-[1.12] mt-4 ${
                    light ? "text-cream" : "text-ink"
                }`}
            >
                {title}
            </h2>
        </Reveal>
        {sub && (
            <Reveal delay={0.16}>
                <p
                    className={`font-body text-base leading-relaxed mt-5 ${
                        light ? "text-cream/70" : "text-inksoft"
                    }`}
                >
                    {sub}
                </p>
            </Reveal>
        )}
    </div>
);
